import React, { useEffect, useState } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import Login from '../auth/Login'
import Layout from '../layout'
import { AuthenticationRoutes } from './routing_menu_list'

export default function Router() {

  const [isAuthenticated, setIsAuthenticated] = useState(false)

  useEffect(() => {
    let isAuth = JSON.parse(localStorage.getItem('is_authenticated'));

    setIsAuthenticated(Boolean(isAuth))
  },[])

  return (
    <Routes>
        <Route 
          path='/login' 
          element={isAuthenticated ? <Navigate to="/" replace /> : <Login />} 
        />
        <Route 
          path='/' 
          element={isAuthenticated ? <Layout /> : <Navigate to="/login" replace />}
        >
          {
            AuthenticationRoutes.map((item, index) => (
              <Route key={index} path={item.path} element={item.component} />
            ))
          }
        </Route>
        <Route 
          path='*' 
          element={isAuthenticated ? <p>404</p> : <Navigate to="/login" replace />} 
        />
    </Routes>
  )
}
